export default __webpack_public_path__ + "static/media/detail_big_15_3.19662f09.jpg";